export default "__VITE_ASSET__NBvbPfLk__"